import Position from "./Position";


function Circle(el, handler) {
    this.el = el;
    this.handler = handler;

    this.positions = [];
    this.r = null;
    this.cx = 0;
    this.cy = 0;
}

Circle.prototype.init = function() {
    this.r = this.el.getAttribute('r') * 1;
    this.cx = this.el.getAttribute('cx') * 1;
    this.cy = this.el.getAttribute('cy') * 1;
}

Circle.prototype.setCoordinates = function(r, cx, cy) {
    this.r = r;
    this.cx = cx;
    this.cy = cy;
}


Circle.prototype.createPositions = function (nb = 0) {
    let angles = this.spreadCoordinates(nb);
    let positions = [];
    for(let i = 0; i < nb; i++) {
        let coordinates = this.getPath(angles[i]);
        positions.push(new Position(coordinates, i));
    }

    return positions;

}

Circle.prototype.spreadCoordinates = function(nb=0) {
    let angles = [];

    if(nb > 0) {
        let start = 0;
        let end = 2 * Math.PI;
        let range = end - start;
        let gap = Math.floor(range / nb * 100) / 100;

        for(let i = start; i < range; i += gap) {
            angles.push(i);
        }
    }

    return angles;
}

Circle.prototype.round = function(nb, precision=100) {
    return Math.floor(nb * precision) / precision;
}

Circle.prototype.getPath = function(angle) {
    // angle += Math.PI;
    let coords = [];
    let length = 300;
    let precision = 10000;
    let twoPi = 2 * Math.PI
    let minMax = 0.02 * twoPi;
    let step = minMax * 2 / length;
    let min = (angle - minMax);
    if(min < 0) {
        min += twoPi;
    }
    let max = (angle + minMax);
    if(max > twoPi) {
        max -= twoPi;
    }

    step = this.round(step, precision);
    min = this.round(min, precision);
    max = this.round(max, precision);

    let reversed = max - min < 0;
    let a = min;

    coords.push(this.calcCoord(a));
    for(let i = 1; i < length; i++) {
        a += step;
        if(reversed) {

            if(a > twoPi) {
                a -= twoPi;
                if(a > max) {
                    a = max;
                }
            }
        } else {
            if(a > max) {
               a = max;
            }
        }

        coords.push(this.calcCoord(a));
    }


    return coords;
}

Circle.prototype.calcCoord = function(angle, precision=1000) {
    return {x: this.calcX(angle, precision=1000), y: this.calcY(angle, precision=1000)};
}

Circle.prototype.calcX = function(angle, precision=1000) {
    return this.round(this.r * Math.cos(angle) + this.cx, precision);
}

Circle.prototype.calcY = function(angle, precision=1000) {
    return this.round(this.r * Math.sin(angle) + this.cy, precision);
}


//anim
// Circle.prototype.prepare = function() {}
// Circle.prototype.animate = function() {}
// Circle.prototype.stop = function() {}

export default Circle;
